module.exports = __webpack_public_path__ + "static/media/450A86DD-1557-4DF6-96B3-99FEF24CAE74-min.3cdb401a.jpg";